import {FC} from 'react'

import {theme} from '@/theme/theme'

import {Icon, IconProps} from './Icon'

export const ShieldPlusIcon: FC<IconProps> = ({color = theme.palette.text.default, size}) => (
  <Icon size={size}>
    <svg width="20" height="21" viewBox="0 0 20 21" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M17.1 4.42074C14.641 4.22673 12.403 3.24765 10.637 1.73252C10.275 1.42249 9.724 1.42249 9.363 1.73252C7.597 3.24665 5.359 4.22673 2.9 4.42074C2.388 4.46075 2 4.89878 2 5.41183V9.74219C2 14.1096 5.156 18.2049 9.478 19.428C9.817 19.524 10.184 19.524 10.523 19.428C14.844 18.2039 18 14.1106 18 9.74319V5.41283C18 4.89878 17.612 4.46075 17.1 4.42074Z"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M7 10.5H13"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M10 13.5V7.5"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  </Icon>
)
